import { useMemo } from 'react'
import { getUrlQueryObject } from '../../../../utils/urls'

export const useUrlQuery = () => {
  const versionUuidFromUrl: string | undefined = useMemo(() => {
    const urlQueryObject = getUrlQueryObject()
    if (!urlQueryObject) return undefined
    const versionUuid = urlQueryObject['versionUuid']
    if (!versionUuid || typeof versionUuid !== 'string') return undefined
    return versionUuid
  }, [])

  const toUrlWithVersionUuid = (versionUuid: string): string => {
    const baseUrl = window.location.origin + window.location.pathname
    return `${baseUrl}?versionUuid=${encodeURIComponent(versionUuid)}`
  }

  return {
    versionUuidFromUrl,
    toUrlWithVersionUuid,
  }
}
